import clsx from 'clsx'
import type { ButtonHTMLAttributes } from 'react'
import '../../styles/slp.css'

export type SlpButtonVariant = 'primary' | 'secondary' | 'danger'

export interface SlpButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: SlpButtonVariant
  size?: 'md' | 'sm'
}

/**
 * SLP button — three variants:
 *  - primary:   blue solid rounded (Connect / Create Session Link style)
 *  - secondary: white body, blue border + blue text
 *  - danger:    red solid (Disconnect / destructive)
 */
export function SlpButton({
  variant = 'primary',
  size = 'md',
  className,
  type,
  ...rest
}: SlpButtonProps) {
  return (
    <button
      type={type ?? 'button'}
      data-variant={variant}
      className={clsx(
        'inline-flex items-center justify-center rounded-md font-semibold leading-none',
        'transition-colors duration-100 focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-45',
        // v2.13: buttons fixed 26px tall (md) — desktop density, no scaling
        size === 'md' ? 'h-[26px] px-3.5 text-[12px]' : 'h-[22px] px-2.5 text-[11px]',
        variant === 'primary' &&
          'border border-[var(--slp-blue-active)] bg-[var(--slp-blue)] text-[var(--slp-blue-text)] hover:bg-[var(--slp-blue-hover)] active:bg-[var(--slp-blue-active)]',
        variant === 'secondary' &&
          'border border-[var(--slp-blue)] bg-[var(--slp-panel)] text-[var(--slp-blue)] hover:bg-[#eaf6fc] active:bg-[#d9eef8]',
        variant === 'danger' &&
          'border border-[var(--slp-red-hover)] bg-[var(--slp-red)] text-white hover:bg-[var(--slp-red-hover)] active:bg-[#a82720]',
        className,
      )}
      {...rest}
    />
  )
}
